import * as serverApi from './server'

export const createCategory = ({ name, color, projectId }) => serverApi.post('/v3/categories', { name, color, projectId })
export const getAll = (queryParams) => serverApi.get('/v3/categories', queryParams)
export const editUrls = (payload) => serverApi.patch('/v3/categories/urls', payload)
export const deleteCategories = (payload) => serverApi.post('/v3/categories/remove', payload)
export const editProducts = (payload) => serverApi.patch('/v3/categories/products', payload)
